import React, { useState } from 'react'
import styled from 'styled-components/macro'
import { getGelTokens } from '@tal-gel/theming'
import { GelHeading2, GelParagraph, GelButton } from '@tal-gel/components'

import Overline from '../Typography/Overline'

const Component = styled.div`
  background-color: ${() => getGelTokens().brand.brandColorPrimary2};
  min-height: 100vh;
  display: flex;
  justify-content: center;

  /* ie11 */
  @media only screen and (-ms-high-contrast: active) and (-ms-high-contrast: none) {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
`

const Wrapper = styled.div`
  padding: 24px 24px;
  display: flex;
  flex-direction: column;

  @media only screen and (min-width: 768px) {
    max-width: 800px;
    padding: 96px 0;
    margin: 0 24px;
  }

  /* ie11 */
  @media only screen and (-ms-high-contrast: active) and (-ms-high-contrast: none) {
    display: block;
    width: 100%;
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
`

const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
`

const Circle = styled.div`
  border-radius: 50%;
  background-color: ${() => getGelTokens().brand.brandColorPrimary2T90};
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Image = styled.img`
  @media only screen and (min-width: 768px) {
    width: 62px;
  }
`

const Body = styled.div`
  margin-top: 80px;

  @media only screen and (min-width: 768px) {
    margin-top: 32px;
  }
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`

const PrevButtonContainer = styled.div`
  /* ie11 */
  @media only screen and (-ms-high-contrast: active) and (-ms-high-contrast: none) {
    position: absolute;
    top: 40px;
  }
`

const ReadMoreWrapper = styled.div`
  display: flex;
  justify-content: center;
`

const QuestionSection = ({
  data,
  onSectionProceed,
  shouldBackButtonExist,
  onBackClick,
  loading
  // mbd,
  // smallerText
}) => {
  const [collapsed, setCollapsed] = useState(true)

  const {
    title,
    imageSection,
    subtitle,
    completion,
    buttonLabel,
    addition,
    readMore
  } = data

  const handleReadMoreClick = () => {
    setCollapsed(!collapsed)
  }

  return (
    <Component>
      <Wrapper>
        <PrevButtonContainer>
          {shouldBackButtonExist && (
            <GelButton
              primary
              medium
              iconLeft='ArrowLeft'
              onClick={onBackClick}
            >
              Prev
            </GelButton>
          )}
        </PrevButtonContainer>
        <Content>
          <ImageContainer>
            <Circle>
              <Image src={imageSection} alt={title} />
            </Circle>
          </ImageContainer>
          <Body>
            {addition && (
              <Overline center white mb={2}>
                {addition}
              </Overline>
            )}
            <GelHeading2
              textAlign='center'
              marginBottom={24}
              inverse
              className={readMore && collapsed && 'readMore'}
            >
              {subtitle}
            </GelHeading2>
            {readMore && collapsed && (
              <ReadMoreWrapper className='readMoreWrapper'>
                <GelButton
                  tertiary
                  medium
                  iconRight='ChevronDown'
                  onClick={handleReadMoreClick}
                  style={{ color: '#fff' }}
                >
                  Read More
                </GelButton>
              </ReadMoreWrapper>
            )}
            <GelParagraph
              large
              marginBottom={24}
              textAlign='center'
              style={{
                fontWeight: '400',
                fontSize: '18px',
                fontFamily: 'Pluto Sans Condensed',
                color: getGelTokens().brand.brandColorPrimary2T50,
                lineHeight: '20px'
              }}
            >
              {completion}
            </GelParagraph>
            <ButtonContainer>
              {loading ? (
                <GelButton primary loading large>
                  {buttonLabel}
                </GelButton>
              ) : (
                <GelButton
                  primary
                  large
                  iconRight='ChevronsRight'
                  onClick={onSectionProceed}
                  style={{
                    fontSize: '12px',
                    minHeight: '56px',
                    minWidth: '196px'
                  }}
                >
                  {buttonLabel}
                </GelButton>
              )}
            </ButtonContainer>
          </Body>
        </Content>
      </Wrapper>
    </Component>
  )
}

export default QuestionSection
